// src/components/Header.js
import axios from "axios";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = ({
  cartItemCount,
  cartTotal,
  toggleMobileNav,
  toggleCartWidget,
}) => {
  const navigate = useNavigate();
  const handlelogout = async () => {
      let baseUrl = "";
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://imw-edu.com/edubackend";
    } else {
      baseUrl = "http://localhost/edubackend";
    }
    const url = `${baseUrl}/logout.php`;
    await axios
      .get(url, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === 200) {
          alert("Loged Out Successfully");
          localStorage.removeItem("user")
          navigate("/");
          window.location.reload();
        }
      });
  };
  const user = localStorage.getItem("user") 
  ? JSON.parse(localStorage.getItem("user")) 
  : null;
  
  return (
    <header className="whb-header whb-default_header whb-sticky-shadow whb-scroll-stick whb-sticky-real">
      <div className="whb-main-header">
        <div className="whb-row whb-general-header whb-not-sticky-row whb-without-bg whb-border-fullwidth whb-color-dark whb-flex-flex-middle">
          <div className="container">
            <div className="whb-flex-row whb-general-header-inner">
              <div className="whb-column whb-col-left whb-visible-lg">
                <div className="site-logo wd-switch-logo">
                  <Link
                    to="/"
                    className="wd-logo wd-main-logo"
                    rel="home"
                    aria-label="Site logo"
                  >
                    <img
                      src="/images/imwedu_logo.svg"
                      alt="Slpe-Edu"
                      style={{ maxWidth: "250px" }}
                    />
                  </Link>
                  <Link to="/" className="wd-logo wd-sticky-logo" rel="home">
                    <img
                      src="/images/Slpe.png"
                      alt="Slpe-Edu"
                      style={{ maxWidth: "150px" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="whb-column whb-col-center whb-visible-lg whb-empty-column"></div>
              {user ===null ? (
                <div className="whb-column whb-col-right whb-visible-lg">
                  <nav
                    className="wd-header-nav wd-header-main-nav text-left wd-full-height wd-design-1"
                    role="navigation"
                    aria-label="Main navigation"
                  >
                    <ul
                      id="menu-main-menu"
                      className="menu wd-nav wd-nav-main wd-style-bordered wd-gap-s"
                    >
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-16 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/" className="woodmart-nav-link">
                          <span className="nav-link-text">Home</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-213 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/about" className="woodmart-nav-link">
                          <span className="nav-link-text">About us</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-213 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/courses" className="woodmart-nav-link">
                          <span className="nav-link-text">COURSES</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-216 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/gallery" className="woodmart-nav-link">
                          <span className="nav-link-text">Gallery</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-214 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/contact" className="woodmart-nav-link">
                          <span className="nav-link-text">Contact us</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-377 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/login" className="woodmart-nav-link">
                          <span className="nav-link-text">Login</span>
                        </Link>
                      </li>
                    </ul>
                  </nav>

                  <div
                    className="wd-header-cart wd-tools-element wd-design-1 cart-widget-opener whb-l0mr2j7hl55d86xj4win"
                    onClick={toggleCartWidget}
                    style={{ cursor: "pointer" }}
                  >
                    <a>
                      {" "}
                      {/* Removed href to prevent navigation, handled by onClick */}
                      <span className="wd-tools-icon"></span>
                      <span className="wd-tools-text">
                        <span className="totalproduct" id="cartTotalproduct">
                          {cartItemCount}
                        </span>
                        <span> items</span>
                        <span className="subtotal-divider">/</span>
                        <span className="wd-cart-subtotal">
                          <span className="woocommerce-Price-amount amount">
                            <bdi>
                              <span className="woocommerce-Price-currencySymbol">
                                ₹
                              </span>
                              <span className="total" id="cartTotal">
                                {cartTotal.toFixed(2)}
                              </span>
                            </bdi>
                          </span>
                        </span>
                      </span>
                    </a>
                  </div>
                  <div
                    id="wd-68371f3f8f239"
                    className="whb-4rj4ldqi1eptuba4rf6q wd-button-wrapper text-center"
                  >
                    <Link
                      to="/cart_checkout"
                      title="Pay Fee"
                      rel="noopener noreferrer"
                      className="btn btn-color-primary btn-style-default btn-shape-rectangle btn-size-default"
                    >
                      Pay Fee
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="whb-column whb-col-right whb-visible-lg">
                  <nav
                    className="wd-header-nav wd-header-main-nav text-left wd-full-height wd-design-1"
                    role="navigation"
                    aria-label="Main navigation"
                  >
                    <ul
                      id="menu-main-menu"
                      className="menu wd-nav wd-nav-main wd-style-bordered wd-gap-s"
                    >
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-16 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/" className="woodmart-nav-link">
                          <span className="nav-link-text">Home</span>
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-213 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/courses" className="woodmart-nav-link">
                          <span className="nav-link-text">COURSES</span>
                        </Link>
                      </li>
                     
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-213 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/history" className="woodmart-nav-link">
                          <span className="nav-link-text">
                            Purchage History
                          </span>
                        </Link>
                      </li>
                       <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-213 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="/profile" className="woodmart-nav-link">
                          <span className="nav-link-text">Profile</span>
                        </Link>
                      </li>

                      <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-377 item-level-0 menu-simple-dropdown wd-event-hover">
                        <Link to="#" className="woodmart-nav-link">
                          <span
                            className="nav-link-text"
                            onClick={handlelogout}
                          >
                            Logout
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </nav>

                  <div
                    className="wd-header-cart wd-tools-element wd-design-1 cart-widget-opener whb-l0mr2j7hl55d86xj4win"
                    onClick={toggleCartWidget}
                    style={{ cursor: "pointer" }}
                  >
                    <a>
                      {" "}
                      {/* Removed href to prevent navigation, handled by onClick */}
                      <span className="wd-tools-icon"></span>
                      <span className="wd-tools-text">
                        <span className="totalproduct" id="cartTotalproduct">
                          {cartItemCount}
                        </span>
                        <span> items</span>
                        <span className="subtotal-divider">/</span>
                        <span className="wd-cart-subtotal">
                          <span className="woocommerce-Price-amount amount">
                            <bdi>
                              <span className="woocommerce-Price-currencySymbol">
                                ₹
                              </span>
                              <span className="total" id="cartTotal">
                                {cartTotal.toFixed(2)}
                              </span>
                            </bdi>
                          </span>
                        </span>
                      </span>
                    </a>
                  </div>
                  <div
                    id="wd-68371f3f8f239"
                    className="whb-4rj4ldqi1eptuba4rf6q wd-button-wrapper text-center"
                  >
                    <Link
                      to="/cart_checkout"
                      title="Pay Fee"
                      rel="noopener noreferrer"
                      className="btn btn-color-primary btn-style-default btn-shape-rectangle btn-size-default"
                    >
                      Pay Fee
                    </Link>
                  </div>
                </div>
              )}

              <div className="whb-column whb-mobile-left whb-hidden-lg">
                <div className="wd-tools-element wd-header-mobile-nav wd-style-icon wd-design-7 whb-wn5z894j1g5n0yp3eeuz">
                  <a
                    href="#"
                    rel="nofollow"
                    aria-label="Open mobile menu"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleMobileNav();
                    }}
                  >
                    <span className="wd-tools-icon"></span>
                    <span className="wd-tools-text">Menu</span>
                  </a>
                </div>
              </div>
              <div className="whb-column whb-mobile-center whb-hidden-lg">
                <div className="site-logo wd-switch-logo">
                  <a
                    href="/"
                    className="wd-logo wd-main-logo"
                    rel="home"
                    aria-label="Site logo"
                  >
                    <img
                      src="/images/Slpe.png"
                      alt="Slpe-Edu"
                      style={{ maxWidth: "140px" }}
                    />
                  </a>
                  {/* Sticky logo for mobile, if needed */}
                </div>
              </div>
              <div className="whb-column whb-mobile-right whb-hidden-lg">
                <div
                  className="wd-header-cart wd-tools-element wd-design-2 cart-widget-opener whb-0mho102tf5fha997f4yn"
                  onClick={toggleCartWidget}
                  style={{ cursor: "pointer" }}
                >
                  <a>
                    {" "}
                    {/* Removed href */}
                    <span className="wd-tools-icon">
                      <span className="wd-cart-number wd-tools-count">
                        {cartItemCount}
                        <span>items</span>
                      </span>
                    </span>
                    <span className="wd-tools-text">
                      <span className="wd-cart-subtotal">
                        <span className="woocommerce-Price-amount amount">
                          <bdi>
                            <span className="woocommerce-Price-currencySymbol">
                              ₹
                            </span>
                            {cartTotal.toFixed(2)}
                          </bdi>
                        </span>
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
